import { createFileRoute } from '@tanstack/react-router';
import { PageSection } from '~/routes/__root';

export const Route = createFileRoute('/partners')({
  component: Partners,
  // loader: async () => getPartners(),
});

const partners = [
  {
    name: 'Kiemelt jelentőségű rendezvény',
    picture: '/partners/optimized/01 kiemelt_jelentosegu_orszagos_rendezveny.webp',
    url: '',
  },
  {
    name: 'Megvalósult',
    picture: '/partners/optimized/01 megvalosult.webp',
    url: '',
  },
  {
    name: 'MNT',
    picture: '/partners/optimized/01_mnt_logo.webp',
    url: 'https://www.mnt.org.rs/',
  },
  {
    name: 'BGA',
    picture: '/partners/optimized/01-bga_alap_logo-_1_.webp',
    url: 'https://bgazrt.hu/',
  },
  {
    name: 'Hangfoglaló',
    picture: '/partners/optimized/03 hangfoglalo-program.webp',
    url: 'https://hangfoglalo.hu/',
  },
  {
    name: 'NKA',
    picture: '/partners/optimized/03 nka2024.webp',
    url: 'https://nka.hu/',
  },
  {
    name: 'PKÜ',
    picture: '/partners/optimized/03_PKÜ_logo-3.webp',
    url: 'https://www.petofiugynokseg.hu/',
  },
  {
    name: 'Orom helyi közösség',
    picture: '/partners/optimized/04_orom-helyi-kozosseg.webp',
    url: 'https://orom.org.rs/new/',
  },
  {
    name: 'Magyarkanizsa önkormányzat',
    picture: '/partners/optimized/05_magyarkanizsa-onkormanyzat.webp',
    url: 'http://www.kanjiza.rs/ujlap/site/index.html',
  },
];

export default function Partners() {
  return (
    <PageSection width="wide" className="grid min-h-[60vh] grid-cols-1 items-center justify-center gap-5 text-center lg:grid-cols-3 lg:flex-row">
      {partners.map((partner, index) => (
        <a
          href={partner.url || '#'}
          key={`partner-${index}`}
          className="debug"
        >
          <img
            src={partner.picture}
            alt={partner.name}
            className={`h-40 md:h-32 ${
              partner.url.length > 0 ? 'cursor-pointer' : ''
            } align-self-center justify-self-center`}
          />
        </a>
      ))}
    </PageSection>
  );
}
